/* do not edit. this file is generated by npm run lib:icons and constantly overwritten */
import React from 'react'
/**
 * @deprecated Use icons from `@chilipiper/icons/figma-generated/src/icon` or
 *   `@chilipiper/icons/figma-generated/src/logo` instead
 */
export const SvgChevronLeft = (props: React.SVGProps<SVGSVGElement>) => (
  <svg fill='none' xmlns='http://www.w3.org/2000/svg' viewBox='0 0 16 16' {...props}>
    <path
      d='M10.335 3.664a1.04 1.04 0 010 1.471L7.471 8l2.864 2.864a1.04 1.04 0 11-1.47 1.471l-3.6-3.6a1.04 1.04 0 010-1.47l3.6-3.6a1.04 1.04 0 011.47 0z'
      fill='currentColor'
    />
  </svg>
)
export default SvgChevronLeft
